var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19984 12.9667L4.3665 8.13333C4.29984 8.06667 4.24984 7.99444 4.2165 7.91667C4.18317 7.83889 4.1665 7.75556 4.1665 7.66667C4.1665 7.48889 4.22762 7.33333 4.34984 7.2C4.47206 7.06667 4.63317 7 4.83317 7H14.9665C15.1665 7 15.3276 7.06667 15.4498 7.2C15.5721 7.33333 15.6332 7.48889 15.6332 7.66667C15.6332 7.71111 15.5665 7.86667 15.4332 8.13333L10.5998 12.9667C10.4887 13.0778 10.3776 13.1556 10.2665 13.2C10.1554 13.2444 10.0332 13.2667 9.89984 13.2667C9.7665 13.2667 9.64428 13.2444 9.53317 13.2C9.42206 13.1556 9.31095 13.0778 9.19984 12.9667Z",
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownGreenIcon);
export default __webpack_public_path__ + "static/media/chevron-down-green-icon.e32b24efc1ac379b0dd691f880a9ef42.svg";
export { ForwardRef as ReactComponent };